import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="transaction-form"
export default class extends Controller {
  static targets = ["checkbox", "creditCardFields"]

  connect() {
    this.toggle()
  }

  toggle() {
    this.creditCardFieldsTarget.classList.toggle("hidden", !this.checkboxTarget.checked)
  }
}
